import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class SerialportService {

    private port: any;
    private options = { baudRate: 9600, dataBits: 8, parity: 'none', bufferSize: 256, flowControl: 'none' }; //Default
    private writer: any;
    private controlCharacter: string = "\n";
    private reader:any;
    private readableStreamClosed:any;
    private writableStreamClosed:any;
    private keepReading:boolean = true;
    private _readedData: Subject<string> = new Subject<string>();
  
    constructor() {
      
    }

    public readData(): Observable<string> {
        return this._readedData.asObservable();
    }

    public sendData(data: string | Uint8Array): Promise<void> {
      if(this.writer === undefined) {
        return Promise.resolve();
      }
      if (!(data instanceof Uint8Array)) {
        const encoder = new TextEncoder();
        data = encoder.encode(data);
      }
      return this.writer.write(data);
    }
  
    private async _readLoop() {
      while (this.port.readable && this.keepReading ) {
        const textDecoder = new TextDecoderStream();
        this.readableStreamClosed = this.port.readable.pipeTo(textDecoder.writable);
        this.reader = textDecoder.readable
          .pipeThrough(new TransformStream(new PrintReadyTransformer()))
          .pipeThrough(new TransformStream(new LineBreakTransformer(this.controlCharacter)))
          .getReader();
  
        try {
          while (true) {
            const { value, done } = await this.reader.read();
            if (done) {
              break;
            }
            if (value) {
              console.log(value);
              this._readedData.next(value);
            }
          }
        } catch (error) {
          console.error("Read Loop error. Have the serial device been disconnected ? ");
          this._readedData.error(error);
        }
      }
      this._readedData.complete();
    }

    public async close(callback:Function) {
      this.keepReading = false;
      this.reader.cancel();
      await this.readableStreamClosed.catch(() => {});
      this.writer.close();
      await this.writableStreamClosed;
      await this.port.close();
      callback(null);
    }
  
    public async connect(options?: any, controlCharacter?: any) {

        if (options)
            this.options = options;
        if (controlCharacter)
            this.controlCharacter = controlCharacter;

      this.keepReading = true;
      if ("serial" in navigator) {
        // The Web Serial API is supported by the browser.
        let nav: any = navigator;
  
        try {
          this.port = await nav.serial.requestPort();
  
        } catch (error) {
          console.error("Requesting port error: " + error);
          return;
        }
  
        try {
         await this.port.open(this.options);
  
  
        } catch (error) {
          console.error("Opening port error: " + error);
          return;
        }
  
        // const textEncoder = new TextEncoderStream();
        // this.writableStreamClosed = textEncoder.readable.pipeTo(this.port.writable);
        // this.writer = textEncoder.writable.getWriter();
        this.writer = this.port.writable.getWriter();
  
        this._readLoop();
  
        // callback(this.port);
  
      } else {
        console.error("This browser does NOT support the Web Serial API");
      }
  
    }

    public isOpen(): boolean {
      return this.port && this.port.opened;
    }
  }
  
  class LineBreakTransformer {
    container: any="";
    private controlCharacter: string;
  
    constructor(controlCharacter: string) {
      this.container = '';
      this.controlCharacter = controlCharacter
    }
  
    transform(chunk:any, controller:any) {
      this.container += chunk;
      const lines = this.container.split(this.controlCharacter);
      this.container = lines.pop();
      lines.forEach((line: any) => controller.enqueue(line));
    }
  
    flush(controller:any) {
      controller.enqueue(this.container);
    }
  }

  class PrintReadyTransformer {
  
    constructor() {
    }
  
    transform(chunk:any, controller:any) {
      console.log(chunk);
      if(chunk.includes('Y')) {
        controller.enqueue('PRINT_READY\n');
      }
      controller.enqueue(chunk);
    }
  
    flush(controller:any) {

    }
  }
